import * as React from 'react'
import PropTypes from 'prop-types'
import Badge from '../Badge'

const FileStatusBadge = ({
  value,
  style,
}) => {
  let colorName = ''
  if (value === 'Draft') {
    colorName = 'magenta'
  } else if (value === 'Interim') {
    colorName = 'blue'
  } else if (value === 'Final') {
    colorName = 'green'
  }

  return <Badge
    value={value}
    colorName={colorName}
    style={style}
  />
}

FileStatusBadge.propTypes = {
  value: PropTypes.oneOf(['Draft', 'Interim', 'Final']),
}

export default FileStatusBadge